import styled from '@emotion/styled/macro';

import { SectionSubTitle } from '../../../Typography/Typography';

export const StyledSectionSubTitle = styled(SectionSubTitle)`
  margin-bottom: 1.5rem;
`;
